import { render, staticRenderFns } from "./pdf-thumbnail.vue?vue&type=template&id=2af597c9"
import script from "./pdf-thumbnail.vue?vue&type=script&lang=js"
export * from "./pdf-thumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports